<template>
  <v-card>
    <v-alert
      v-model="successDialog"
      dismissable
      prominent
      type="success"
      transition="scale-transition"
    >
      Item successfully saved!
    </v-alert>
    <v-alert
      v-model="errorDialog"
      dismissible
      prominent
      type="error"
      transition="scale-transition"
    >
      Something went wrong
    </v-alert>
    <v-card-title
      primary-title
      style="flex-direction: column;"
    >
      <div class="headline">
        Create User
      </div>
      <div>
        <v-form
          v-model="valid"
          @submit.prevent="onCreateUser"
          @keydown.prevent.enter
        >
          <v-text-field
            v-model="user.firstName"
            :error-messages="firstNameErrors"
            label="First Name"
            required
            @input="$v.user.firstName.$touch()"
            @blur="$v.user.firstName.$touch()"
          />
          <v-text-field
            v-model="user.lastName"
            :error-messages="lastNameErrors"
            label="Last Name"
            required
            @input="$v.user.lastName.$touch()"
            @blur="$v.user.lastName.$touch()"
          />
          <v-text-field
            v-model="user.email"
            :error-messages="emailErrors"
            label="Email"
            required
            @input="$v.user.email.$touch()"
            @blur="$v.user.email.$touch()"
          />
          <phone-component @phoneSet="setPhone" />
          <v-btn
            type="submit"
            :disabled="!valid"
          >
            Create
          </v-btn>
        </v-form>
      </div>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import {
  required, minLength, maxLength, numeric, email,
} from 'vuelidate/lib/validators';
import User from '../models/user';
import PhoneComponent from './PhoneComponent.vue';

export default {
  name: 'NewUserForm',
  components: {
    PhoneComponent,
  },
  props: {
    clientId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    dialog: false,
    fullPage: true,
    valid: false,
    user: new User(),
    successDialog: false,
    errorDialog: false,
  }),
  computed: {
    firstNameErrors() {
      const errors = [];

      if (!this.$v.user.firstName.$dirty) {
        return errors;
      }

      if (!this.$v.user.firstName.required) {
        errors.push('First name is required');
      }

      return errors;
    },
    lastNameErrors() {
      const errors = [];

      if (!this.$v.user.lastName.$dirty) {
        return errors;
      }

      if (!this.$v.user.lastName.required) {
        errors.push('Last name is required');
      }

      return errors;
    },
    emailErrors() {
      const errors = [];

      if (!this.$v.user.email.$dirty) {
        return errors;
      }

      if (!this.$v.user.email.required) {
        errors.push('Email address is required');
      }

      if (!this.$v.user.email.email) {
        errors.push('Please enter a valid email address');
      }

      if (!this.$v.user.email.isUnique) {
        errors.push('This email address is already in use');
      }

      return errors;
    },
  },
  validations: {
    user: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      email: {
        required,
        email,
        async isUnique(value) {
          if (value === '') {
            return true;
          }

          if (this.$v.user.email) {
            const unique = await this.validateEmail();
            return Boolean(unique);
          }

          return false;
        },
      },
      phone: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
    },
  },
  methods: {
    ...mapActions('apiClient', ['get', 'create']),
    ...mapMutations('apiClient', ['dismissError']),
    setPhone(val) {
      this.user.phone = val;
    },
    async validateEmail() {
      let valid = true;

      await this.get({ url: '/users/checkEmail', params: { email: this.user.email } }).then(
        (response) => {
          valid = !response.data.used;
        },
        (error) => {
          console.log(error);
          valid = false;
        },
      );

      return valid;
    },
    async onCreateUser() {
      if (this.clientId) {
        this.user.clientId = this.clientId;
      }

      this.create({ url: '/users', body: this.user }).then(
        (response) => {
          this.successDialog = true;
          this.user = response.data;
          this.dialog = false;
          this.$emit('userCreated', response.data);
          setTimeout(() => {
            this.successDialog = false;
          }, 5000);
        },
        (error) => {
          this.errorDialog = true;
          console.log(error);
          setTimeout(() => {
            this.errorDialog = false;
          }, 5000);
        },
      );
    },
  },
};
</script>
